import { styled } from '@mui/material';

import { linkable } from '../../routing';
import { colorSystem } from '../../theme';
import { BaseButton, LinkButton } from './BaseButton';

const neutralButtonStyle = {
    background: colorSystem.neutral[9],
    color: colorSystem.neutral.white,
    border: `1px solid ${colorSystem.neutral[9]}`,

    '&:hover': {
        background: colorSystem.neutral[8],
    },
    '&:active': {
        background: colorSystem.neutral[7],
    },
    '&:disabled': {
        background: colorSystem.neutral[5],
        color: colorSystem.neutral.white,
        border: `1px solid ${colorSystem.neutral[5]}`,
    },
};

const NeutralButtonHost = styled(BaseButton)(neutralButtonStyle);
const NeutralButtonLinkHost = styled(LinkButton)(neutralButtonStyle);

export const NeutralButton = linkable(NeutralButtonHost, { linkHost: NeutralButtonLinkHost });
